
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.45 4.25a.5.5 0 00.277-.083l1.069-.713c1.263-.842 2.954.063 2.954 1.581v4.716a3.1 3.1 0 01-3.1 3.1h-5.6a3.1 3.1 0 01-3.1-3.1v-2.4a3.1 3.1 0 013.1-3.1h4.4z","stroke":"#56BFC7","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4.25 16.051a.5.5 0 00-.312.11l-.101.08.312.39-.312-.39c-1.244.996-3.087.11-3.087-1.483V10.55a3.1 3.1 0 013.1-3.1h5.6a3.1 3.1 0 013.1 3.1v2.4a3.1 3.1 0 01-3.1 3.1h-5.2z","fill":"#fff","stroke":"#56BFC7","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.25 11.451a.5.5 0 01.5-.5h3a.5.5 0 110 1h-3a.5.5 0 01-.5-.5z","fill":"#56BFC7"}})])
          )
        }
      }
    